import { InjectionKey } from 'vue';

export const globalWindowKey: InjectionKey<Window> = Symbol();
